"use strict";

var wallEndpoint = function wallEndpoint(_ref) {
  var wallId = _ref.wallId;
  return "walls/" + wallId;
};

var privacyPolicyEndpoint = function privacyPolicyEndpoint(_ref2) {
  var privacyPolicyId = _ref2.privacyPolicyId;
  return "privacy_policies/" + privacyPolicyId;
};

var contributorSearchEndpoint = function contributorSearchEndpoint(_ref3) {
  var query = _ref3.query,
      limit = _ref3.limit;
  limit = limit || 5;
  return "search/collaborators?q=" + encodeURIComponent(query) + "&limit=" + limit;
};

var sendInvitationEndpoint = function sendInvitationEndpoint(_ref4) {
  var privacyPolicyId = _ref4.privacyPolicyId;
  return "privacy_policies/" + privacyPolicyId + "/reinvite";
};

module.exports = {
  wallEndpoint: wallEndpoint,
  privacyPolicyEndpoint: privacyPolicyEndpoint,
  contributorSearchEndpoint: contributorSearchEndpoint,
  sendInvitationEndpoint: sendInvitationEndpoint
};